import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { compose } from "redux";
import { IBreadcrumbBarItem } from "component-library";
import { PremiumEntitlements } from "shared-types";
import { doesUserHaveEntitlements } from "shared-auth";
import { MY_FILTERS_FULL_PATH, PageTitleKey } from "config/common";
import config from "config/global";
import PageKey from "config/PageKey";

import { IApplicationState } from "store";
import { getPageTranslation } from "store/translation/translation.actions";
import { GetPageTranslation } from "store/translation/translation.types";
import { hidePopup, setLoading, showPopup } from "store/ui/ui.actions";

import { IAgentQuickSearchPageTranslation } from "models/translation";

import { getPageTitle } from "helpers/getPageTitle";

import withPageData, {
  ILoaders,
  IWithPageDataProps,
  mapStateToWithPageDataProps,
} from "hoc/withPageData";

import { AgentSearchPage } from "./AgentSearchPage";

interface IAgentSearchPageWrapperProps extends IWithPageDataProps {
  breadcrumbs: IBreadcrumbBarItem[];
  translations: IAgentQuickSearchPageTranslation;
  pageTitle: string;
  getPageTranslation: GetPageTranslation;
}

export class AgentSearchPageWrapper extends React.Component<IAgentSearchPageWrapperProps> {
  render() {
    const isAccessAllowed = doesUserHaveEntitlements(
      PremiumEntitlements.Premium_Performer_Search
    ); // method includes check for agent role type

    if (!isAccessAllowed) return <Navigate to={MY_FILTERS_FULL_PATH} />;

    return <AgentSearchPage {...this.props} />;
  }
}

const pageDataLoaders: ILoaders<IAgentSearchPageWrapperProps> = {
  loadTranslation(props, isLocaleChanged) {
    return props.getPageTranslation(
      { pageKey: PageKey.AgentQuickSearch, locale: props.locale },
      { throwOnError: isLocaleChanged }
    );
  },
};

const mapStateToProps = (state: IApplicationState) => {
  const pageTranslation = state.translation.pages[PageKey.AgentQuickSearch]!;
  const commonTranslation = state.translation.common;

  return {
    pageTitle: getPageTitle(commonTranslation, PageTitleKey.AgentQuickSearch),
    breadcrumbs: [
      {
        url: `${config.siteRootUrl}myhome`,
        text: pageTranslation.header.breadcrumb[0].Translation,
      },
    ],
    translations: pageTranslation,
  };
};

const mapDispatchToProps = {
  setLoading,
  getPageTranslation,
  showPopup,
  hidePopup,
};

export default compose(
  connect(mapStateToWithPageDataProps, mapDispatchToProps),
  withPageData<IAgentSearchPageWrapperProps>(
    PageKey.AgentQuickSearch,
    pageDataLoaders
  ),
  connect(mapStateToProps, mapDispatchToProps)
)(AgentSearchPageWrapper);
